import mitt from '@webcore/core/events/mitt';

export type LocalizationEvents = {
  'switch-to-localization': void;
  'switch-to-placing': void;
  'restart-localization': void;
  'request-localization-state': void;
  'localization-mode-changed': 'localizing' | 'placing';
  'localization-success-count': { count: number; threshold: number };
  'localization-threshold-reached': { count: number; threshold: number };
};

const localizationEvents = mitt<LocalizationEvents>();

export default localizationEvents;
